<!--<ul class="navbar">
  <li class="nav-item active">

  </li>
  <li class="nav-item">
    <a class="nav-link" href="#" (click)="savectu()">
      <i class="fa-2x mr-2 fas fa-close"></i>
      Đóng
    </a>
    <a class="nav-link" href="#" (click)="closeModal()">
    <i class="fa-2x mr-2 fa fa-window-close">
    </i>
    Thoát
  </a>
  </li>
</ul>-->

<div class="TOP">
  <div class="row" style=" height:34px; background-color:#36BC9B; width: 99%; color:White; font-size:large; font-weight:bold ; padding-left:1%">
    <div class="col-6"> Nơi nhận xử lý</div>
    <div class="col-6" style="float:right">
      <a style="font-size:small !important;color:red;float:right" class="nav-link" (click)="savectu()">
        <i class="fa-2x mr-2 fas fa-close"></i>
        <!--Đóng-->
      </a>
    </div>
  </div>



  <div class="lbl_left">Nơi nhận:</div>
  <div class="lbl_right" style="padding-left:1%;">
    <input name="lblNoiNhanChiDao" type="text" id="lblNoiNhanChiDao" disabled="disabled" class="csstxt" [(ngModel)]="TimKiems.NN_NoiNhanHienThi" style="font-weight:bold;width:99%;">
  </div>
  
</div>


<!-- lưới chi tiết -->
<div style="padding: 2px 10px 10px 10px;color:black !important;height: calc(100vh - 300px);width:auto">
  <div class="control-section">
    <ejs-treegrid [dataSource]='data' height='400' autoCheckHierarchy='true' childMapping='children' [editSettings]='editSettings' [treeColumnIndex]='0' (queryCellInfo)="queryCellInfo($event)">
      <e-columns>
        <e-column field='Ten' headerText='Đơn vị' textAlign='Left' editType='stringedit' width=750></e-column>
        <e-column field='Chon' headerText='Chọn' textAlign='Center' editType='booleanedit' type='boolean' displayAsCheckBox='true' width=100></e-column>
      </e-columns>
    </ejs-treegrid>

  </div>

</div>





<div class="modal-footer" style="display: flex;justify-content: space-between;margin-top:5px;">
  <!--<div>
    <div *ngIf="totalItems>=10">
      <ul class="pagination">
        <li [ngClass]="{disabled: currentPage === 1}">
          <a (click)="setPage(1)"><<</a>
        </li>
        <li [ngClass]="{disabled:currentPage === totalPages}">
          <a (click)="setPage(currentPage + 1)">></a>
        </li>
        <li *ngFor="let page of pages" [ngClass]="{active: currentPage === page.Id}">
          <a (click)="setPage(page.Id)">{{page.Id}}</a>
        </li>
        <li [ngClass]="{disabled:currentPage === 1}">
          <a (click)="setPage(currentPage - 1)"><</a>
        </li>
        <li [ngClass]="{disabled:currentPage === totalPages}">
          <a (click)="setPage(totalPages)">>></a>
        </li>
        <li>
          <input type="number" style="width:50px;height:30px;text-align:center" [(ngModel)]="pageSize" (blur)="search1()" />
        </li>
        <li><span style="font-weight:bold">Tổng số: {{totalItems | number}}</span></li>
      </ul>
    </div>
  </div>-->
  <div class="">
    <div class="Bottom">
      <div style="float:right; width:120px; padding-right:15px;margin-right:10px">
        <button id="cmdClose" class="css_btn" (click)="savectu()">Đóng</button>
      </div>
      <!--<div style="float:right; width:410px;"></div>-->
    </div>

  </div>

</div>


